module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_23.e0101392.mp3";